import { useTranslation } from 'react-i18next'
import { ReservationF } from '../../types/reservation-detail.types'
import ReferenceForm from './reference-form'
import { ReferenceFormSchema } from './reference-form.hook'
import { useTenant } from 'src/app/hooks/context/context.hook'
import { useReservationUpdateMutation } from 'src/api/api.generated'
import useErrorSnackBar from 'src/app/hooks/error-snack-bar/error-snack-bar'

type ReferenceFormDialogProps = {
  reservation: ReservationF
  open: boolean
  onClose: () => void
}

export default function ReferenceFormDialog({ reservation, open, onClose }: ReferenceFormDialogProps) {
  const { t } = useTranslation()
  const tenantId = useTenant().id
  const showErrorSnackBar = useErrorSnackBar()
  const [updateReservationMutation, { loading }] = useReservationUpdateMutation()

  async function onSubmit(data: ReferenceFormSchema) {
    const result = await updateReservationMutation({
      variables: {
        id: reservation.id,
        input: {
          tenantId,
          reference: {
            mainGuestId: data.mainGuestId,
            customerPersonId: data.customerPersonId,
            customerCompanyId: data.customerCompanyId,
            agencyId: data.agencyId,
          },
        },
      },
      refetchQueries: ['ReservationSearch'],
      onError: showErrorSnackBar,
    })
    if (!result.errors) onClose()
  }

  return (
    <ReferenceForm
      title={t('pms.booking.reservation.header.menu.customer')}
      appearance={{ type: 'DIALOG', open, onClose, maxWidth: '360px' }}
      reservation={reservation}
      onCancel={onClose}
      onSubmit={onSubmit}
      loading={loading}
    />
  )
}
